import { routes } from "./RoutesList.js";

export { routes }
